<ng-template #progressSpinnerRef>
  <svg class="gradient-defs" width="0" height="0">
    <defs>
      <linearGradient id="spinnerGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="19.05%" style="stop-color:rgba(113, 197, 93, 0);stop-opacity:1" />
        <stop offset="84.05%" style="stop-color:#71C55D;stop-opacity:1" />
      </linearGradient>
    </defs>
  </svg>
  <div class="d-flex align-items-center justify-content-center flex-column gap-32">
    <mat-progress-spinner class="main-spiner" [color]="color" [diameter]="sizeDiameter()" [mode]="mode" [strokeWidth]="strokeWidthSize()" [value]="value">
    </mat-progress-spinner>
    <span class="spinner-text">{{ allStatus.textSpinner }}</span>
  </div>
</ng-template>
